/* eslint-disable no-unused-vars */
import React from "react";

// eslint-disable-next-line react/prop-types
function BellIcon({ width = 12.8, height = 16 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 12.8 16"
    >
      <path
        id="notifications_FILL0_wght400_GRAD0_opsz24"
        d="M4,15.6V14H5.6V8.4a4.686,4.686,0,0,1,1-2.95A4.615,4.615,0,0,1,9.2,3.76V3.2a1.2,1.2,0,1,1,2.4,0v.56a4.615,4.615,0,0,1,2.6,1.69,4.686,4.686,0,0,1,1,2.95V14h1.6v1.6ZM10.4,9.6Zm0,8.4a1.6,1.6,0,0,1-1.6-1.6H12A1.6,1.6,0,0,1,10.4,18ZM7.2,14h6.4V8.4a3.209,3.209,0,0,0-3.2-3.2A3.209,3.209,0,0,0,7.2,8.4Z"
        transform="translate(-4 -2)"
        fill="#707070"
      />
    </svg>
  );
}

export default BellIcon;
